/**
 * 跳转App逻辑, 目前有唤醒qq，唤醒微视
 */
import { isIOS, isAndroid, isNewWeChat, isChrome } from '@tencent/h5-env-enhance';
import { wsSchema } from '@tencent/weishi-lib';
import { MqqAndriodTpl, MqqChromeAfterTpl, MqqChromeTpl, MqqSchemaTpl, QQSchemaList } from './common';
/**
 * 跳转至下载页面
 * @param url 下载链接url
 */
var downloadApp = function (url) {
    console.log('download app***************', url);
    window.location.href = url;
};
/**
 * 判断schema是否合规
 * @param url schema
 */
var isUrlInSchemaList = function (url) {
    var reg = /^http(s)?:\/\/([\w\-]+[\.])+qq\.com($|\/)/;
    var isInSchema = QQSchemaList.some(function (l) { return new RegExp(l).test(url); });
    return reg.test(url) || isInSchema;
};
/**
 * 处理 url
 * @param url schema
 */
var appendSchemaUrl = function (url) {
    if (isAndroid()) {
        return isChrome() ? "" + MqqChromeTpl + btoa(url) + MqqChromeAfterTpl : "" + MqqAndriodTpl + btoa(url) + "&t=" + new Date().getTime();
    }
    else if (isIOS()) {
        return "" + MqqSchemaTpl + btoa(url) + "&t=" + new Date().getTime();
    }
};
/**
 * 从微信跳转到qq
 * @param url 微信跳qq的schema
 */
var wechatJumpToQQ = function (schemaUrl, config) {
    console.log('call: WeixinJSBridge');
    var wakeUpFailCb = function () {
        if (!config.downloadWhenWakeupFail)
            return;
        var downloadUrl = isAndroid() ? config.androidDownloadUrl : config.iOSDownloadUrl;
        downloadUrl && downloadApp(downloadUrl);
    };
    WeixinJSBridge &&
        WeixinJSBridge.invoke('launchApplication', {
            schemeUrl: schemaUrl,
        }, function (res) {
            console.log('call: WeixinJSBridge:result', res);
            // 没有安装 APP
            if (res.err_msg === 'launchApplication:fail') {
                wakeUpFailCb();
                return;
            }
            // 能够唤起,但是用户取消操作 >> 不做处理
            if (res.err_msg === 'launchApplication:ok') {
                return;
            }
        });
};
/**
 * qq唤醒
 * @param shcemaUrl qq 内的shcema
 * @param downloadUrl 未安装 qq 时下载链接
 */
var wakeUpQQ = function (shcemaUrl, config) {
    shcemaUrl = isUrlInSchemaList(shcemaUrl) ? shcemaUrl : '';
    if (!/^mqqapi:\/\//.test(shcemaUrl)) {
        shcemaUrl = appendSchemaUrl(shcemaUrl);
    }
    if (isNewWeChat()) {
        // 新版本微信下使用新方式拉起
        if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
            console.log('env: weixin(ready)');
            wechatJumpToQQ(shcemaUrl, config);
        }
        else {
            console.log('env: weixin(listen)');
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', function () {
                    console.log('env: weixin(listen:emit:WeixinJSBridgeReady)');
                    wechatJumpToQQ(shcemaUrl, config);
                }, false);
            }
            else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', function () {
                    console.log('env: weixin(listen:emit:WeixinJSBridgeReady)');
                    wechatJumpToQQ(shcemaUrl, config);
                });
                document.attachEvent('onWeixinJSBridgeReady', function () {
                    console.log('env: weixin(listen:emit:onWeixinJSBridgeReady)');
                    wechatJumpToQQ(shcemaUrl, config);
                });
            }
        }
    }
    else if (isAndroid()) {
        if (isChrome()) {
            window.location.href = shcemaUrl;
            return;
        }
        var jumpIframe_1 = document.createElement('iframe');
        jumpIframe_1.style.cssText = 'display: none;width: 0px; height: 0px';
        setTimeout(function () {
            jumpIframe_1.src = shcemaUrl;
            document.body.append(jumpIframe_1);
        }, 500);
    }
    else {
        window.location.href = shcemaUrl;
    }
};
/**
 * 检验是否安装微视
 * @param handler 回调
 */
var isInstalledWeiShi = function (handler) {
    // weishi 提供的检验是否安装weishi的sdk
    wsSchema.load().then(function (downloader) {
        downloader.isAppInstall({
            cb: function (res) {
                handler(res);
            }
        });
    });
};
/**
 * 唤醒微视
 * @param schema 微视schema
 * @param downloadIOSUrl 下载链接
 * @param downloadAndroidUrl 下载链接
 */
var wakeUpWeishi = function (schema, config) {
    var wakeUpFailCb = function () {
        if (!config.downloadWhenWakeupFail)
            return;
        window.location.href = isAndroid() ? config.androidDownloadUrl : config.iOSDownloadUrl;
    };
    isInstalledWeiShi(function (str) {
        if (str === 'yes') {
            wsSchema.openSchema(schema);
        }
        else {
            wakeUpFailCb();
        }
    });
};
export { wakeUpQQ, wakeUpWeishi, };
